const types = {
  SET_SYSTEM_USERS: "SET_SYSTEM_USERS",
  ADD_OR_UPDATE_SYSTEM_USER: "ADD_OR_UPDATE_SYSTEM_USER",
  REMOVE_SYSTEM_USER: "REMOVE_SYSTEM_USER",

  SET_DEGREES: "SET_DEGREES",
  SET_SPECIALIZATIONS: "SET_SPECIALIZATIONS",
  SET_TEACHER_PROFILE: "SET_TEACHER_PROFILE",

  SET_PROFILE_DOCUMENT_TYPES: "SET_PROFILE_DOCUMENT_TYPES",
  SET_PROFILE_DOCUMENTS: "SET_PROFILE_DOCUMENTS",
  SET_SCHOOL_LEADERS_EVALUATIONS: "SET_SCHOOL_LEADERS_EVALUATIONS",

  // Appeal action types
  SET_CURRENT_APPEAL: "SET_CURRENT_APPEAL",
  SET_MY_APPEALS: "SET_MY_APPEALS",
};

export default types;
